import React from 'react';
import { Box } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound';
import EuroIcon from '@mui/icons-material/Euro';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const iconSx = (selected) => ({
  fontSize: 14,
  color: 'inherit',
  opacity: selected ? 0.95 : 0.85,
});

export const getBookingCurrencyIcon = (currencyCode) => {
  const code = String(currencyCode || '').toUpperCase();
  if (code === 'EUR') return EuroIcon;
  if (code === 'GBP') return CurrencyPoundIcon;
  if (code === 'USD' || code === 'CAD' || code === 'AUD' || code === 'NZD') return AttachMoneyIcon;
  return MonetizationOnIcon;
};

const BookingTimeSlotCoins = ({
  hasDifferentialPricing,
  hasAdditionalCost,
  currencyCode,
  selected = false,
}) => {
  if (!hasDifferentialPricing) {
    return null;
  }

  const Icon = getBookingCurrencyIcon(currencyCode);
  const count = hasAdditionalCost ? 2 : 1;

  return (
    <Box
      component="span"
      sx={{
        position: 'absolute',
        right: 8,
        bottom: 5,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.1,
        lineHeight: 0,
        pointerEvents: 'none',
      }}
    >
      {Array.from({ length: count }, (_, index) => (
        <Icon key={index} sx={iconSx(selected)} />
      ))}
    </Box>
  );
};

export default BookingTimeSlotCoins;
